import { render } from "./FeaturedSlide.vue?vue&type=template&id=ba04e784"
import script from "./FeaturedSlide.vue?vue&type=script&lang=js"
export * from "./FeaturedSlide.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ktl/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__